import React, { useState } from "react";
import { useStatsigClient } from "@foundation/statsig";

import {
    getSearchTipDismissalValueFromLocalStorage,
    SearchTipPopover,
} from "./SearchTipPopover";

const LOCAL_STORAGE_DISMISSAL_KEY = "navSearchTipDismissed";

export const NewSearchTip = () => {
    const [tipEnabledInStatsig, setTipEnabledInStatsig] = useState(false);
    const {
        checkGate,
        client: { loadingStatus },
    } = useStatsigClient();

    const anchorEl =
        typeof document !== "undefined" &&
        document.querySelector(
            '[data-component="nav"] [aria-label="search-button"]'
        );

    const previouslyDismissedPopover =
        getSearchTipDismissalValueFromLocalStorage(LOCAL_STORAGE_DISMISSAL_KEY);

    if (!anchorEl || previouslyDismissedPopover) {
        return null;
    }

    if (loadingStatus === "Ready") {
        const latestGateValue = checkGate("new_search_tip");
        if (latestGateValue !== tipEnabledInStatsig) {
            setTipEnabledInStatsig(latestGateValue);
        }
    }

    return (
        tipEnabledInStatsig && (
            <SearchTipPopover
                localStorageDismissalKey={LOCAL_STORAGE_DISMISSAL_KEY}
                anchorEl={anchorEl}
                eyebrow="Try our new search"
                text="Improved results and navigation to help you find what matters."
            />
        )
    );
};
